import React from "react"
import { Link } from "gatsby"

export const MessageUpdateInfoModal = ({
  message_update_info_modal_open,
  application_required,
  set_message_update_info_modal_open,
}) => {
  const close_cta_modal = () => {
    set_message_update_info_modal_open(false)
  }
  return (
    <div
      className={`modal${message_update_info_modal_open ? " is-active" : ""}`}
    >
      <div
        className="modal-background"
        onClick={close_cta_modal}
        role="button"
        tabIndex="0"
        onKeyDown={() => {}}
        aria-label="Close CTA Modal"
      ></div>
      <div className="modal-content">
        <div
          className="box mx-auto is-flex is-flex-direction-column"
          style={{ maxWidth: 530, minHeight: 350 }}
        >
          <p className="title is-5 mb-2 has-text-mitternachtsblau">
            Updates zu Mitteilungen und Bieterfragen
          </p>
          <hr className="is-mitternachtsblau-30 my-3" />
          {application_required ? (
            <div
              className="has-text-mitternachtsblau mb-5 content"
              style={{ minHeight: 200 }}
            >
              Mitteilungen der Vergabestelle können Antworten auf{" "}
              <Link to="/vergabe-wissen/lexikon/bieterfragen" className="link">
                Bieterfragen
              </Link>{" "}
              sowie wichtige Hinweise zur Erstellung von Teilnahmeanträgen und
              Angeboten erhalten. Um stets relevante{" "}
              <Link
                to="/vergabe-wissen/lexikon/teilnahmeantrag"
                className="link"
              >
                Teilnahmeanträge
              </Link>{" "}
              und{" "}
              <Link
                to="/vergabe-wissen/lexikon/angebote-im-vergabeverfahren"
                className="link"
              >
                Angebote
              </Link>{" "}
              zu erstellen, empfehlen wir Ihnen, sich zu registrieren. Wir
              informieren Sie dann per E-Mail, wenn es eine neue Mitteilung der
              Vergabestelle zu diesem Verfahren gibt.
            </div>
          ) : (
            <div
              className="has-text-mitternachtsblau mb-5 content"
              style={{ minHeight: 200 }}
            >
              Mitteilungen der Vergabestelle können Antworten auf{" "}
              <Link className="link" to="/vergabe-wissen/lexikon/bieterfragen">
                Bieterfragen
              </Link>{" "}
              sowie wichtige Hinweise zur Angebotserstellung erhalten. Um stets
              ein relevantes Angebot zu erstellen, empfehlen wir Ihnen, sich zu{" "}
              <Link
                className="link"
                to="/ausschreibungsdienste/preise?produkt=bieterassistent"
              >
                registrieren
              </Link>
              . Wir informieren Sie dann per E-Mail, wenn es eine neue
              Mitteilung der Vergabestelle zu diesem Verfahren gibt.
            </div>
          )}

          <button
            className="ml-auto is-tertiary button has-text-weight-bold"
            onClick={close_cta_modal}
          >
            Schließen
          </button>
        </div>
      </div>
    </div>
  )
}
